class LimitedEditionDetailsTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('.le-tabs__tab')];
    this.panels = [...this.querySelectorAll('.le-tabs__panel')];

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab));
    });

    this.navWrap = this.querySelector('.le-tabs__nav-wrap');
    this.nav = this.querySelector('.le-tabs__nav');
    if (this.navWrap && this.nav) {
      this.nav.addEventListener('scroll', () => this.updateScrollFade());
      window.addEventListener('resize', () => this.updateScrollFade());
      this.updateScrollFade();
    }
  }

  updateScrollFade() {
    const { scrollWidth, clientWidth, scrollLeft } = this.nav;
    const hasOverflow = scrollWidth > clientWidth + 1;
    const hasMore = scrollWidth - clientWidth - scrollLeft > 1;
    this.navWrap.classList.toggle('has-overflow', hasOverflow);
    this.navWrap.classList.toggle('has-more', hasMore);
  }

  activate(tab) {
    this.tabs.forEach((t) => {
      const isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.getAttribute('aria-labelledby') === tab.id;
      panel.classList.toggle('is-active', isActive);
      panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    // inline: 'center' scrolls the nav's own horizontal overflow, not the
    // page -- block: 'nearest' is what keeps it from also trying to
    // vertically scroll the whole page toward the tab. On mobile this is
    // what actually surfaces "The Timeline" and the rest of the row that
    // would otherwise stay partly off-screen after a tap; on desktop the
    // nav doesn't overflow so this is a no-op.
    tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }
}

customElements.define('limited-edition-details-tabs', LimitedEditionDetailsTabs);
